import { SpintrTypes } from "src/typings";

/**
 * Whether a loaded widget has nothing to show ("Det finns inget innehåll").
 * Leaderboards and upcoming events have their own empty states.
 */
export const hasNoContent = (response: Pick<Spintr.IMarketplaceWidgetDataResponse, "displayType" | "data">): boolean => {
    if (response.displayType === SpintrTypes.WidgetType.Leaderboard ||
        response.displayType === SpintrTypes.WidgetType.UpcomingEvents) {
        return false;
    }

    const data = response.data;

    if (data === null || data === undefined) {
        return true;
    }

    if (Array.isArray(data)) {
        return data.length === 0;
    }

    if (response.displayType === SpintrTypes.WidgetType.KeyPointIndicator) {
        return data.value === null || data.value === undefined || data.value === "";
    }

    return false;
};
